export default "__VITE_ASSET__YikNTYHh__"